import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'
import { CoverageImpactMessage } from 'partner360/features/topPartnersManagement/components/coverageImpactMessage/CoverageImpactMessage'
import { RequestStatus } from 'partner360/features/topPartnersManagement/components/topPartnerEditor/topPartnerEditorContent/components/requestStatus/RequestStatus'
import { ICoverageImpact } from 'partner360/features/topPartnersManagement/models'
import { TRANSLATION_KEYS } from 'partner360/features/topPartnersManagement/translations'
import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

const KEYS = TRANSLATION_KEYS.topPartners.removeFlag

interface IRemoveFlagConfirmationDialogProps {
  item: IPartnerWithFlagRequests | null
  partnerFlags: IP360PartnerFlags[]
  flagTitle?: string
  coverageImpact: ICoverageImpact | null
  isVisible: boolean
  hasActiveRequest: boolean
  isApplyDisabled: boolean
  onConfirm: () => void
  onReject: () => void
}

export const RemoveFlagConfirmationDialog: FC<IRemoveFlagConfirmationDialogProps> = ({
  item,
  partnerFlags,
  flagTitle,
  coverageImpact,
  isVisible,
  hasActiveRequest,
  isApplyDisabled,
  onConfirm,
  onReject,
}) => (
  <ConfirmationDialog
    isVisible={isVisible}
    title={hasActiveRequest ? KEYS.removeRequestConfirmTitle : KEYS.createRequestConfirmTitle}
    content={
      <div>
        <Translation
          text={
            hasActiveRequest ? KEYS.removeRequestConfirmContent : KEYS.createRequestConfirmContent
          }
          replaceParams={[{ key: '{flagName}', value: flagTitle ?? '' }]}
        />
        {!hasActiveRequest && coverageImpact && (
          <CoverageImpactMessage
            coverageImpact={coverageImpact}
            translationKey={KEYS.coverageImpact}
            tone="decrease"
            extraReplaceParams={[{ key: '{market}', value: item?.GeoMarket ?? '' }]}
          />
        )}
        {hasActiveRequest && item && <RequestStatus item={item} partnerFlags={partnerFlags} />}
      </div>
    }
    confirmBtnText={KEYS.confirmBtn}
    rejectBtnText={KEYS.cancelBtn}
    isApplyDisabled={isApplyDisabled}
    isApplyNegative
    onConfirm={onConfirm}
    onReject={onReject}
  />
)

RemoveFlagConfirmationDialog.displayName = 'RemoveFlagConfirmationDialog'
